module.exports = __webpack_public_path__ + "static/logo-9c2ce85162e0b6365083eac13f83cf88.png";